import { H5, Image } from '@helloself/hello-self-ui';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import React from 'react';

import { parseApiErrorMessage } from '../../../../../api/apiErrorResponseHelper';
import { BaseTileProps, ExpertInsurer } from '../../../model/types';
import Tile from '../../Tile';
import { InsurerIcons } from './InsurerIcons';

export type InsurerTileProps = BaseTileProps & {
    insurers: ExpertInsurer[] | undefined;
    error?: FetchBaseQueryError | SerializedError | undefined;
};

export function InsurerTile({ insurers, isLoading, error }: InsurerTileProps) {
    if ((!insurers || insurers.length === 0) && !isLoading) {
        return null;
    }

    const insurerIcons = insurers
        ? insurers.map(({ imageBase64, imageMimeType, organisationId, organisationName }) => (
              <Image
                  key={organisationId}
                  size={40}
                  src={`data:${imageMimeType};base64,${imageBase64}`}
                  alt={`${organisationName} insurer image`}
              />
          ))
        : [];

    const loadingError = parseApiErrorMessage(error);

    return (
        <Tile>
            <H5 margin={'0 0 24px'} data-testid="InsurerTile">
                Insurers I work with
            </H5>
            <InsurerIcons isLoading={isLoading} errorMessage={loadingError} icons={insurerIcons} />
        </Tile>
    );
}
